import { Modal, Input, Button, theme } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { t } from 'i18next'
import SelectSource, { selectSourcePrivacyTypes } from './SelectSource'
import SelectTimePeriod, {
  SelectTimePeriodOnChangeParams,
} from './SelectTimePeriod'
import AllowClearIcon from './display/AllowClearIcon'
import { DataSource } from '../store/reducers/dataSourceReducer'

const { Search } = Input
const { useToken } = theme

interface MainHeaderSearchModalProps {
  isVisible: boolean
  onClose: () => void
  onSearch: (searchText: string) => void
  onSourceChange: (value: DataSource | undefined) => void
  onTimePeriodChange: (values: SelectTimePeriodOnChangeParams) => void
  searchText: string
  onSearchTextChange: (text: string) => void
  loading?: boolean
  searchLoading?: boolean
  searchButtonStyle?: React.CSSProperties
}

const MainHeaderSearchModal = ({
  isVisible,
  onClose,
  onSearch,
  onSourceChange,
  onTimePeriodChange,
  searchText,
  onSearchTextChange,
  loading,
  searchLoading,
  searchButtonStyle,
}: MainHeaderSearchModalProps) => {
  const { token } = useToken()

  const renderSearchInput = () => (
    <Search
      placeholder={t('mainHeader.searchPlaceholder') || ''}
      allowClear={{
        clearIcon: <AllowClearIcon />,
      }}
      value={searchText}
      onChange={(e) => onSearchTextChange(e.target.value)}
      onSearch={onSearch}
      disabled={searchLoading || loading}
      loading={searchLoading || loading}
      enterButton={
        <Button style={searchButtonStyle} icon={<SearchOutlined />} />
      }
      style={{
        flex: 1,
      }}
      styles={{
        affixWrapper: {
          backgroundColor: token.colorBgContainer,
          border: `1px solid ${token.colorBorder}`,
        },
        prefix: {
          backgroundColor: token.colorBgContainer,
          color: token.colorText,
        },
        input: {
          backgroundColor: token.colorBgContainer,
          color: token.colorText,
        },
        suffix: {
          color: token.colorText,
          backgroundColor: `${token.colorBgLayout} !important`,
        },
      }}
    />
  )

  return (
    <Modal
      title={t('mainHeader.search') || ''}
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width="80%"
      style={{
        top: '20%',
      }}
      styles={{
        content: {
          backgroundColor: token.colorBgContainer,
        },
     
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <SelectSource
          onChange={onSourceChange}
          privacy={selectSourcePrivacyTypes.PUBLIC}
          includeSearchable={true}
        />
        <SelectTimePeriod onChange={onTimePeriodChange} />
        {renderSearchInput()}
      </div>
    </Modal>
  )
}

export default MainHeaderSearchModal
